import { createGlobalStyle } from 'styled-components';
import tw, { css, theme } from 'twin.macro';

// TODO: Check if we need this anymore
// const inputBaseStyles = css`
//   input:-webkit-autofill:focus,
//   textarea:-webkit-autofill:focus,
//   select:-webkit-autofill:focus {
//     -webkit-text-fill-color: ${theme`colors.transparent`};
//     background-color: transparent;
//   }

//   input:-webkit-autofill,
//   textarea:-webkit-autofill,
//   select:-webkit-autofill,
//   input:-webkit-autofill:hover,
//   textarea:-webkit-autofill:hover,
//   select:-webkit-autofill:hover {
//     -webkit-text-fill-color: ${theme`colors.transparent`};
//     background-color: transparent;
//   }
// `;

const AuthStyle = createGlobalStyle(
  {
    body: tw`bg-page-background`,
    h3: tw`text-base text-text-and-icon-muted font-semibold text-center`,
    p: tw`text-xs text-text-and-icon-muted text-center`,
    a: tw`text-accent-2 underline`,
    // TODO: Sync with design team on variable for #D6D6FF value
    input: tw`autofill:shadow-[0 0 0px 1000px #D6D6FF inset] aria-selected:shadow-[0 0 0px 1000px #D6D6FF inset] peer-autofill:shadow-[0 0 0px 1000px #D6D6FF inset]`,
  }
  // inputBaseStyles
);

export default AuthStyle;
